import { injectable } from "inversify"
import container from "../wires/Bootstrapper"
import SERVICE_IDENTIFIER from "../wires/Identifiers"
import { IApiService } from "./shared/ApiService"
import * as Api from "../constants/ApiUrlConstants"
import { StressTestInputModel, StressTestListModel, StressTestModel, StressTestRettificaModel, StressTestRettificheRowModel } from "../models/StressTestModels"
import { ModelBase } from "../models/ModelBase"

export interface IStresstestService {
    GetStressTestList(clienteId: string): Promise<StressTestListModel>
    GetStressTest(Id?: string): Promise<StressTestModel>
    SaveStressTest(data: StressTestInputModel): Promise<ModelBase>
    SaveNomeStressTest(Id: string, NomeStresstest: string): Promise<ModelBase>
    Delete(Id: string): Promise<ModelBase>
    GetRettifica(Id: string): Promise<StressTestRettificaModel>
    DeleteRettifica(Id: string, stressTestId: string): Promise<ModelBase>
    SaveRettifica(model: StressTestRettificaModel): Promise<StressTestRettificaModel>
    Export(stressTestId: string)
}

@injectable()
export class StresstestService implements IStresstestService {

    apiService: IApiService

    constructor() {
        this.apiService = container.get(SERVICE_IDENTIFIER.API_SERVICE);
    }

    async GetStressTestList(clienteId: string): Promise<StressTestListModel> {
        return await this.apiService.getAsync<StressTestListModel>(Api.StressTestGetList, { ClienteId: clienteId });
    }

    async GetStressTest(Id?: string): Promise<StressTestModel> {
        return await this.apiService.getAsync<StressTestModel>(Api.StressTestGet, { Id });
    }

    async SaveStressTest(data: StressTestInputModel): Promise<StressTestModel> {
        return await this.apiService.postAsync<StressTestModel>(Api.StressTestSave, data);
    }

    async SaveNomeStressTest(Id: string, NomeStresstest: string): Promise<ModelBase> {
        return await this.apiService.getAsync<StressTestModel>(Api.StressTestSaveNome, { Id: Id, NomeStresstest: NomeStresstest });
    }

    async Delete(Id: string): Promise<ModelBase> {
        return await this.apiService.getAsync<ModelBase>(Api.StressTestDelete, { Id: Id });
    }

    async GetRettifica(Id: string): Promise<StressTestRettificaModel> {
        return await this.apiService.getAsync<StressTestRettificaModel>(Api.StressTestGetRettifica, { rettificaId: Id });
    }

    async DeleteRettifica(Id: string, stressTestId:string): Promise<ModelBase> {
        return await this.apiService.getAsync<ModelBase>(Api.StressTestDeleteRettifica, { rettificaId: Id, stressTestId });
    }

    async SaveRettifica(model: StressTestRettificaModel): Promise<StressTestRettificaModel> {
        return await this.apiService.postAsync<StressTestRettificaModel>(Api.StressTestSaveRettifica, model);
    }

    Export(stressTestId: string) {
        let url = "/api" + Api.StressTestExport + "?stresstestid=" + stressTestId
        this.apiService.downloadFileToken(url);
    }
}